export default __webpack_public_path__ + "static/media/search.ad5a2923.svg";